import {
  type AnimationOptionWipe,
  type AnimationWipeFunction,
} from "@package/ui-gql/index-data-access";
import { type CSSProperties, useMemo } from "react";
import { type AnimationComponentProps } from "./animated-card-interface";

const wipeFunctionMap: { [key in AnimationWipeFunction]: string } = {
  box: "animated-card-box",
  chevron: "animated-card-chevron",
  circle: "animated-card-circle",
  down: "animated-card-down",
  ellipse: "animated-card-ellipse",
  inset: "animated-card-inset",
  polygon: "animated-card-polygon",
  shutters: "animated-card-shutters",
  slots: "animated-card-slots",
  spiral: "animated-card-spiral",
  spotlight: "animated-card-spotlight",
  star: "animated-card-star",
};

export function AnimationCardWipe({
  animation,
  nodeCurr,
  nodePrev,
  reversed,
}: AnimationComponentProps<AnimationOptionWipe>) {
  const styleCardBack = useMemo<CSSProperties>(
    () => ({
      animationDuration: `${animation.duration}s`,
      animationName:
        wipeFunctionMap[animation.function] ?? wipeFunctionMap.down,
      animationDirection: "reverse",
    }),
    [animation.duration, animation.function],
  );

  return (
    <div className="relative w-full h-full">
      <div className="absolute w-full h-full">
        {reversed ? nodeCurr : nodePrev}
      </div>
      <div
        key={`${reversed}`}
        className="absolute w-full h-full"
        style={styleCardBack}
      >
        {reversed ? nodePrev : nodeCurr}
      </div>
    </div>
  );
}
